import { render, staticRenderFns } from "./Sample_in.vue?vue&type=template&id=a950c094&scoped=true"
import script from "./Sample_in.vue?vue&type=script&lang=js"
export * from "./Sample_in.vue?vue&type=script&lang=js"
import style0 from "./Sample_in.vue?vue&type=style&index=0&id=a950c094&prod&lang=css"
import style1 from "./Sample_in.vue?vue&type=style&index=1&id=a950c094&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a950c094",
  null
  
)

export default component.exports